import useLocale from '@hooks/useLocale'
import type { IMoney } from '@utils/money'
import { formatMoney } from '@utils/money'
import type React from 'react'

export interface MoneyProps {
  money: IMoney
}

export const Money: React.FC<MoneyProps> = ({ money }) => {
  const { locale } = useLocale()
  return formatMoney(locale, money)
}

Money.displayName = 'Money'
export default Money
